<template>
  <div id="page" class="container-fluid p-0">

    <div>
      <b-navbar class="nav-contingent" toggleable="lg">
        <b-navbar-brand>
          <img class="logo-bba" src="@/assets/img/bba/logo.png" alt="BBA"/>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-text class="email font-weight-bold">{{ login }}</b-nav-text>
            <b-nav-item>
              <logout-button class="text-right" size="sm" />
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
<!--      <b-navbar type="light" fixed="top" class="border-bottom" toggleable="xl">-->
<!--        <b-navbar-toggle target="nav_collapse" />-->
<!--        <b-collapse is-nav id="nav_collapse">-->
<!--          <b-navbar-nav class="row navbar-login">-->
<!--            <b-nav-text>{{ login }}</b-nav-text>-->
<!--            <logout-button class="text-right" size="sm" />-->
<!--          </b-navbar-nav>-->
<!--        </b-collapse>-->
<!--      </b-navbar>-->
    </div>
    <div class="hotel-details">
      <router-view id="page-content" class="container-fluid back-page-content" role="main" />
    </div>

    <footer class="footer text-center">
      Pour toute question, vous pouvez contacter BBA ( du lundi au vendredi de 9h à 19h ) au <a href="tel:01 49 21 55 91">01 49 21 55 91</a> ou par email à <a href="mailto:cnfpt@groupebba-bma.com">cnfpt@groupebba-bma.com</a><br>
      © 2024 Copyright: <a href="https://www.teicee.com" title="Création d'applications Web" target="_blank">téïcée</a> / <a href="https://bba.groupebba-bma.com/" target="_blank" title="Réservation d'hôtels pour voyages d'affaire">B.B.A.</a>
    </footer>

    <b-modal :title="errorTitle" ref="errorModal" ok-only centered
             @ok="$router.go(-1)"
    >
      {{ errorMsg }}
    </b-modal>

  </div>
</template>

<script>
import axios from 'axios'
import bNavbar from 'bootstrap-vue/es/components/navbar/navbar'
import bNavbarNav from 'bootstrap-vue/es/components/navbar/navbar-nav'
import bNavbarToggle from 'bootstrap-vue/es/components/navbar/navbar-toggle'
import bNavbarBrand from 'bootstrap-vue/es/components/navbar/navbar-brand'
import bNavItem from 'bootstrap-vue/es/components/nav/nav-item'
import bNavItemDropdown from 'bootstrap-vue/es/components/nav/nav-item-dropdown'
import bNavText from 'bootstrap-vue/es/components/nav/nav-text'
import bDropdownItem from 'bootstrap-vue/es/components/dropdown/dropdown-item'
import bCollapse from 'bootstrap-vue/es/components/collapse/collapse'
import logoutButton from '@/components/backoffice/button/logout'
import showComponent from '@/components/backoffice/show/showComponent.vue'
import CommonApi from '@/api/commonApi'

export default {
  components: {
    showComponent,
    bNavbarToggle,
    bNavItemDropdown,
    bNavbarNav,
    bNavItem,
    bNavbar,
    logoutButton,
    bNavText,
    bDropdownItem,
    bCollapse,
    bNavbarBrand,
  },

  data () {
    return {
      errorTitle: '',
      errorMsg: ''
    }
  },

  async created () {
    this.errorTitle = this.$t('error.error')
    this.errorMsg = this.$t('error.error')

    axios.interceptors.response.use(undefined, (err) => {
      return new Promise(() => {
        if (err.response !== undefined) {
          switch (err.response.status) {
            case 403:
              this.errorMsg = this.$t('error.403')
              this.$refs.errorModal.show()
              break
            case 500:
            case 503:
            default:
              this.errorMsg = this.$t('error.500back')
              this.$refs.errorModal.show()
              break
          }
          throw err
        }
      })
    })
  },

  computed: {
    login: function () {
      return this.$store.getters['security/login']
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/sass/main.scss";
@import "@/assets/sass/backoffice/button.scss";

.logo-bba{
  width: 150px;
}

.nav-contingent{
  border-bottom: 1px solid #d9d9d9;
}

.email{
  line-height: 40px;
  margin-right: 10px;
  color: rgba(0, 0, 0, 1) !important;
}

.nav-link button{
  border-radius: 12px;
  background-color: white;
  border: 1px solid black
}

.hotel-details{
  margin: 3%;

  h2:first-child{
    text-align: center;
    margin-bottom: 3%;
    margin-top: 3%;
  }

  h2 .btn{
    border-radius: 12px;
    margin-right: 10px;
    background-color: #e65011 !important;
    border: 1px solid rgba(0,0,0,0.5);
  }

  .border-top{
    margin: 0;
  }

  .field{
    padding: 10px;
  }
}

.card-body{
  padding: 0;
}

//.card-footer a {
//  display: none !important;
//}

.page-item.active .page-link {
  background-color: $darkBlue;
  border-color: $darkBlue;
}

.page-item.active .page-link:hover {
  color: white;
}

.page-link {
  color: $darkBlue;
}

.page-link:hover {
  color: $darkBlueDarker;
}

.vuetable-slot .btn-group > .btn {
  flex: none !important;
  border-radius: 12px !important;
  border: none !important;
}

.card-footer button{
  border-top-left-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
  border-top-right-radius: 12px !important;
  border-bottom-right-radius: 12px !important;
  background-color: #d9d9d9 !important;
}
</style>
